import { render, staticRenderFns } from "./NewSimulatorMain.vue?vue&type=template&id=63861356&scoped=true&"
import script from "./NewSimulatorMain.vue?vue&type=script&lang=js&"
export * from "./NewSimulatorMain.vue?vue&type=script&lang=js&"
import style0 from "./NewSimulatorMain.vue?vue&type=style&index=0&id=63861356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63861356",
  null
  
)

export default component.exports